var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalPendingInternsh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.369,
    height: 20.039,
    viewBox: "0 0 18.369 20.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contract-pending-line-svgrepo-com",
    transform: "translate(-109.84 -73.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M111.51,74.73h13.359v9.185h1.67V73.06h-16.7V93.1h9.182v-1.67H111.51Z",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M256.13,219.34h10.02v1.67H256.13Zm0,3.34h8.349v1.67H256.13Zm0,3.34h5.01v1.67h-5.01Zm10.854,1.67a4.175,4.175,0,1,0,4.175,4.175A4.175,4.175,0,0,0,266.984,227.69Zm0,6.68a2.5,2.5,0,1,1,2.5-2.5A2.508,2.508,0,0,1,266.984,234.369Z",
    transform: "translate(-142.95 -142.94)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M705.383,692.08H704.13v1.992l1.584,1.57.881-.89-1.213-1.2Z",
    transform: "translate(-580.722 -604.887)",
    fill: "#136ad0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPendingInternsh);
export default __webpack_public_path__ + "static/media/total-pending-internsh.470945f40d297666d881eeb08c6ed3a5.svg";
export { ForwardRef as ReactComponent };